import * as React from "react";
import { forwardRef } from "react";
const SvgNavigationPanelRightReveal = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={17} height={10} viewBox="0 0 17 10" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g stroke="#348CFD" strokeWidth={1.5} fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round"><path d="M10.856 5.078H1M5.078 1 1 5.078l4.078 4.078M15.582 9.156V1" /></g></svg>;
const ForwardRef = forwardRef(SvgNavigationPanelRightReveal);
export { ForwardRef as ReactComponent };